<template>
  <div class="max-w-2xl mx-auto">
    <h2 class="text-lg mb-4 font-bold">{{ __("Notifications") }}</h2>

    <form class="mx-auto" @submit.prevent="submit()">

      <div class="mb-6">
        <textarea-input rows="4" v-model="form.feedbackRequestText" :label="__('Job feedback text')" :data-error="validationError('value.feedbackRequestText')"></textarea-input>
      </div>

      <div class="mt-6 flex justify-center">
        <loading-button type="submit" :loading="submitting" class="justify-center text-xl px-4 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300">
          {{ __("Save") }}
        </loading-button>
      </div>
    </form>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import SettingsLayout from '@/Shared/SettingsLayout';
  import TextInput from '@/Shared/TextInput';
  import TextareaInput from '@/Shared/TextareaInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import Icon from '@/Shared/Icon';

  export default {
    layout: (h, page) => {
      return h(Layout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
      return {
        title: this.__("Notifications"),
      }
    },
    props: {
      notifications: Object
    },
    data() {
      return {
        submitting: false,
        form: {
          feedbackRequestText: null
        }
      }
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      TextareaInput,
      Icon
    },
    mounted() {
      this.form = this.notifications;
    },
    methods: {
      submit() {
        this.submitting = true;
        this.$inertia.put(this.route('settings.update', {key: 'notifications'}), {
          value: this.form
        }, {preserveState: false})
      }
    }
  }
</script>
